<template>
  <div id="container">
    <!-- 使用封装的导航栏组件 -->
    <TheNavbar />

    <!-- Divider -->
    <hr class="mt-0 mb-0 " />
    <!-- End Divider -->

    <!-- BANNER -->
    <div style="width: 100%;">
      <div style="width: 100%;" id="mainbanner">
        <div class="floating-welcome-box" id="floatingWelcomeBox">
          How to become a member ?<br />
          <button class="register-btn" id="registerNowBtn" @click="memberRegistration">Register Now</button>
        </div>
       
        <div id="mainBannerCarousel" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="banner-img d-block w-100" alt="AOGS Society Banner"
                src="@/assets/society/isacibanner.jpg"
                style="height: 500px; object-fit: cover; object-position: center;">
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- BANNER -->
    <div style="width: 100%; overflow: hidden;" id="mob">
      <div style="width: 100%; margin-right: auto;">
        <img class="banner-img" alt="Responsive image" src="@/assets/society/isacibanner.jpg"
          style="width: 100%;">
      </div>
    </div>

    <br />

    <div class="container container-layout">
      <!-- <div class="modal fade bd-example-modal-xl" id="modal1" tabindex="-1" role="dialog"
        aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content mdl_content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalScrollableTitle">AOGS2022</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div style="width: 100%;">
                <br />
                <img class="banner-img" alt="Responsive image" src="@/assets/society/img/AOGS2022V2-09.png"
                  style="width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <br />

      <section class="main-content">
        <div class="container">
          <div class="row">
            <!-- Announcements Column -->
            <div class="col-lg-4 mb-4">
              <div class="announcements-card loading">
                <div class="announcements-header">Workshop List</div>
                <div class="card-body p-0">
                  <div class="announcement-item">
                    <div class="announcement-title">The Asian and Oceania Workshop on Data, Inference and Security </div>
                     <router-link to="/ISACI2025" class="announcement-link">  14 - 16 Nov 2025 ● Penang, Malaysia
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- Main Content Column -->
            <div class="col-lg-8">
              <!-- About Section -->
              <div class="loading">
                <div class="card border-0 shadow-sm">
                  <div class="card-body p-4">
                    <div class="col-12" id="aboutUS">
                      <h2 class="AOGSSOCIETYsubheadline-p1">ABOUT ISACI</h2>
                      <hr align="left" class="AOGSSOCIETY_horizl" />
                    </div>
                    <div class="col-12">
                      <p>The International Society for Applied and Computational Imaging (ISACI) is a Singapore-based non-profit
                        organization dedicated to advancing interdisciplinary collaboration in the field of imaging sciences. With
                        a focus on the Asia-Pacific and Oceania regions, ISACI aims to strengthen academic communication and
                        foster innovation by organizing high-quality workshops and conferences on a monthly to weekly basis.</p>
                      <p>The society's activities center around three core areas of expertise:</p>
                      <ul style="list-style-type: disc; padding-left: 20px;">
                        <li>Geophysical Imaging</li>
                        <li>Medical Imaging</li>
                        <li>Nondestructive Testing</li>
                      </ul>
                      <p>Through its events, ISACI provides a dynamic platform for researchers, professionals, and students to
                        exchange ideas, showcase cutting-edge work, and explore emerging technologies at the intersection of
                        imaging, data science, and computational methods.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Feature Cards -->
              <div class="row mb-4">
                <div class="col-md-4 mb-3">
                  <div class="feature-card loading">
                    <router-link to="/official/geophysical">
                      <img style="width: 100%;"
                        src="@/assets/society/img/myimages/5a10f515-4902-452b-8099-01faa2f665cc.png" alt="">
                    </router-link>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="feature-card loading">
                    <router-link to="/official/medical-imaging">
                      <img style="width: 100%;"
                        src="@/assets/society/img/myimages/d8c82e32-37df-4add-b4e1-021a40368f90.png" alt="">
                    </router-link>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="feature-card loading">
                    <router-link to="/official/nondestructive-testing">
                      <img src="@/assets/society/img/myimages/7e49329b-38c4-4871-a352-383b64b60c6a.png" alt="">
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- About Section -->
              <!-- <div class="loading">
                <div class="card border-0 shadow-sm">
                  <div class="card-body p-4">
                    <div class="col-12" id="aboutUS">
                      <h2 class="AOGSSOCIETYsubheadline-p1">ABOUT ISACI</h2>
                      <hr align="left" class="AOGSSOCIETY_horizl" />
                    </div>
                    <div class="col-12">
                      <p>The International Society for Applied and Computational Imaging (ISACI) is a Singapore-based non-profit
                        organization dedicated to advancing interdisciplinary collaboration in the field of imaging sciences. With
                        a focus on the Asia-Pacific and Oceania regions, ISACI aims to strengthen academic communication and
                        foster innovation by organizing high-quality workshops and conferences on a monthly to weekly basis.</p>
                      <p>The society's activities center around three core areas of expertise:</p>
                      <ul style="list-style-type: disc; padding-left: 20px;">
                        <li>Geophysical Imaging</li>
                        <li>Medical Imaging</li>
                        <li>Nondestructive Testing</li>
                      </ul>
                      <p>Through its events, ISACI provides a dynamic platform for researchers, professionals, and students to
                        exchange ideas, showcase cutting-edge work, and explore emerging technologies at the intersection of
                        imaging, data science, and computational methods.</p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>
      <hr />
      <br />

      <!-- <div class="row">
        <div class="col-sm-12">
          <hr />
          <br />

          <div class="row">
            <div class="col-6">
              <h6 class="AOGSSOCIETYsubheadline-p1"><i class="fa fa-handshake-o"></i>&nbsp; OUR PARTNERS</h6>
              <hr align="left" class="AOGSSOCIETY_horizl" />
            </div>
            <div class="col-6 text-right">
              <div class="btn-group btn-group-lg" role="group" aria-label="Basic outlined example">
                <button class="btn mb-3 mr-1" type="button" data-bs-target="#carouselExampleIndicators2"
                  data-bs-slide="prev">
                  <i class="fa fa-arrow-left" style="color: #175480;"></i>
                </button>
                <button class="btn mb-3" type="button" data-bs-target="#carouselExampleIndicators2"
                  data-bs-slide="next">
                  <i class="fa fa-arrow-right" style="color: #175480;"></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              <div id="carouselExampleIndicators2" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="row">
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 1.png">
                          <div class="card-body">
                            <p class="card-text"><a href="https://www.agu.org/" target="_blank">American Geophysical
                                Union</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 2.png">
                          <div class="card-body">
                            <p class="card-text"><a href="https://www.amos.org.au/" target="_blank">Australian
                                Meteorological and Oceanographic Society</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 3.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://rwes.dpri.kyoto-u.ac.jp/~tanaka/APHW/APHW.html"
                                target="_blank">Asia Pacific Association of Hydrology and Water Resources</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 4.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://center.shao.ac.cn/APSG/" target="_blank">Asia-Pacific
                                Space Geodynamics</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 11.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://www.cgu.org.tw/index.php" target="_blank">Chinese
                                Geoscience Union in Taiwan</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 5.png">
                          <div class="card-body">
                            <p class="card-text"><a href="https://www.egu.eu/" target="_blank">European Geosciences
                                Union</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="row">
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 6.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://www.iugg.org/" target="_blank">International Union Of
                                Geodesy And Geophysics</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 7.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://www.jpgu.org/" target="_blank">Japan Geoscience
                                Union</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 10.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://www.koreagu.or.kr/" target="_blank">Korea Geoscience
                                Union</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 8.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://www.scj.go.jp/" target="_blank">Science Council of
                                Asia</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 9.png">
                          <div class="card-body">
                            <p class="card-text"><a href="http://seg.org/" target="_blank">Society of Exploration
                                Geophyscists</a></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-2 mb-2">
                        <div class="card AOGSSOCIETY_PARTNERS_CARD">
                          <img class="img-fluid" alt="100%x280" src="@/assets/society/img/AOGS PARTNER 1.png">
                          <div class="card-body">
                            <p class="card-text"><a href="https://www.agu.org/" target="_blank">American Geophysical
                                Union</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <br />
    <br />
    <TheFooter />
  </div>
</template>

<script>
  import TheNavbar from '@/components/TheNavbar.vue'
  import TheFooter from '@/components/TheFooter.vue'
  export default {
    name: 'Index',
    components: {
      TheNavbar,
      TheFooter
    },
    methods: {
      MM_openBrWindow(theURL, winName, features) {
        window.open(theURL, winName, features);
      }
    },
    watch: {
      // 监听路由变化，处理锚点滚动
      '$route'(to, from) {
        if (to.hash) {
          this.$nextTick(() => {
            const element = document.getElementById(to.hash.substring(1));
            if (element) {
              setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth' });
              }, 500);
            }
          });
        }
      }
    },
    methods: {
      memberRegistration() {
        this.$router.push('/registration');
      }
    },
    mounted() {
      // 处理初始锚点滚动
      this.$nextTick(() => {
        if (this.$route.hash) {
          const element = document.getElementById(this.$route.hash.substring(1));
          if (element) {
            // 延迟滚动，确保页面完全加载
            setTimeout(() => {
              element.scrollIntoView({ behavior: 'smooth' });
            }, 500);
          }
        }
      });

      // 还原浮动框滚动显示逻辑
      const box = document.getElementById('floatingWelcomeBox');
      // 确保Bootstrap轮播图正确初始化
      if (typeof bootstrap !== 'undefined') {
        new bootstrap.Carousel(document.getElementById('mainBannerCarousel'), {
          interval: 5000,
          wrap: true
        });
      }
      // 还原浮动框滚动显示逻辑
      if (box) {
        window.addEventListener('scroll', function () {
          if (window.scrollY > 130) {
            box.classList.add('show');
          } else {
            box.classList.remove('show');
          }
        });
      }

      // 确保轮播图正确初始化
      this.$nextTick(() => {
        setTimeout(() => {
          const carouselElement = document.getElementById('carouselExampleIndicators2');
          if (carouselElement) {

            const carouselItems = carouselElement.querySelectorAll('.carousel-item');
            carouselItems.forEach((item, index) => {});
          } else {
            console.log('轮播图元素未找到');
          }
        }, 1000);
      });
    }
  }
</script>

<style scoped>
  /* 原始index.asp.html的样式 */
  :root {
    --primary-color: #175480;
    --secondary-color: #99C33C;
    --accent-color: #f8f9fa;
    --text-dark: #2c3e50;
    --text-light: #6c757d;
    --border-color: #e9ecef;
    --shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);
    --transition: all 0.3s ease;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* 确保container-layout样式正确 */
  .container-layout {
    width: 100%;
    max-width: 1344px;
    margin: 0 auto;
  }

  .main-content {
    padding: 2rem 0;
  }

  .section-title {
    color: var(--primary-color);
    font-weight: 600;
    margin-bottom: 1.5rem;
    position: relative;
    padding-bottom: 0.5rem;
  }

  .section-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background: var(--secondary-color);
    border-radius: 2px;
  }

  .announcements-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: none;
    height: 680px;
    border-radius: 16px;
    box-shadow: var(--shadow);
    overflow: hidden;
    transition: var(--transition);
  }

  .announcements-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }

  .announcements-header {
    background: linear-gradient(135deg, var(--secondary-color) 0%, #1a6ba8 100%);
    color: white;
    padding: 1rem;
    text-align: center;
    font-weight: 600;
  }

  .announcement-item {
    padding: 1rem;
    border-bottom: 1px solid var(--border-color);
    transition: var(--transition);
  }

  .announcement-item:last-child {
    border-bottom: none;
  }

  .announcement-item:hover {
    background-color: var(--accent-color);
  }

  .announcement-title {
    font-weight: 600;
    color: var(--primary-color);
    margin-bottom: 0.5rem;
  }

  .announcement-link {
    color: var(--secondary-color);
    text-decoration: none;
    font-weight: 500;
    transition: var(--transition);
  }

  .announcement-link:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }

  /* Feature Cards - 完全按照原始index.asp.html的样式 */
  .feature-card {
    background: white;
    border: none;
    border-radius: 16px;
    box-shadow: var(--shadow);
    text-align: center;
    transition: var(--transition);
    height: 100%;
    overflow: hidden;
  }

  .feature-card:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-lg);
  }

  .feature-card a {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
  }

  .feature-card a:hover {
    text-decoration: none;
  }

  .feature-card img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 16px 16px 0 0;
  }

  .feature-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    background: linear-gradient(135deg, var(--primary-color) 0%, #1a6ba8 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 2rem;
  }

  .feature-title {
    color: var(--primary-color);
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .btn-primary {
    background: linear-gradient(135deg, var(--primary-color) 0%, #1a6ba8 100%);
    border: none;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    transition: var(--transition);
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow);
  }

  /* Carousel */
  .carousel {
    /* border-radius: 16px; */
    /* overflow: hidden; */
    box-shadow: var(--shadow);
  }

  .carousel-item img {
    transition: var(--transition);
  }

  .carousel-control-prev,
  .carousel-control-next {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    width: 40px;
    height: 40px;
    top: 50%;
    transform: translateY(-50%);
  }

  /* 浮动框样式 - 原始index.asp.html的样式 */
  .floating-welcome-box {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, 100px);
    z-index: 9999;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 24px 32px;
    min-width: 320px;
    max-width: 90vw;
    font-size: 25px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s cubic-bezier(.4, 0, .2, 1),
      transform 0.4s cubic-bezier(.4, 0, .2, 1);
  }

  .floating-welcome-box.show {
    opacity: 1;
    pointer-events: auto;
    transform: translate(-50%, 0);
  }

  .floating-welcome-box .register-btn {
    margin-top: 18px;
    padding: 10px 28px;
    /* background: linear-gradient(135deg, #175480 0%, #1a6ba8 100%); */
    background: #ffffff;
    color: #1a6ba8;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
  }

  .floating-welcome-box .register-btn:hover {
    /* background: linear-gradient(135deg, #1a6ba8 0%, #175480 100%); */
    background: #1a6ba8;
    color: #ffffff;
  }

  /* 合作伙伴样式 */
  .society-container {
    justify-content: space-between;
    flex-direction: column;
    height: 100vh;
    display: flex;
  }

  .society-container .btn-holder {
    justify-content: flex-end;
    display: flex;
  }

  .announcement-hr {
    background-color: #99C33C;
    border: 0 none;
    color: #99C33C;
    height: 1.2px;
  }

  /* 确保内容区域正确居中 */
  .container.container-layout {
    width: 100%;
    max-width: 1344px;
    margin: 0 auto;
    padding: 0 15px;
  }

  /* 确保卡片样式正确 */
  .card {
    border: none;
    box-shadow: var(--shadow);
    border-radius: 16px;
    overflow: hidden;
  }

  .card-body {
    padding: 1.5rem;
  }

  /* 确保加载动画 */
  .loading {
    opacity: 1;
    /* margin-bottom: 20px; */
    transition: opacity 0.3s ease;
  }

  /* Bootstrap网格系统修复 */
  .row {
    margin-left: -15px;
    margin-right: -15px;
  }

  .col-md-4,
  .col-lg-4,
  .col-lg-8 {
    padding-left: 15px;
    padding-right: 15px;
  }

  /* 确保特色卡片之间有足够间距 */
  .row.mb-4 {
    /* margin-bottom: 2rem !important; */
    margin-top: 2rem !important;
  }

  /* 响应式样式 */
  @media (max-width: 768px) {
    .floating-welcome-box {
      font-size: 20px;
      padding: 20px 24px;
      min-width: 280px;
    }

    .announcements-card {
      height: 500px;
    }
  }

  /* 合作伙伴轮播容器 */
  #carouselExampleIndicators2 {
    margin-top: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    min-height: 250px;
  }



  #carouselExampleIndicators2 .carousel-item .row {
    align-items: center;
    justify-content: center;
    margin: 0;
    width: 100%;
  }

  /* 确保轮播图内容可见 */
  #carouselExampleIndicators2 .carousel-item {
    opacity: 1 !important;
    visibility: visible !important;
    position: relative;
  }

  #carouselExampleIndicators2 .carousel-item.active {
    opacity: 1 !important;
    visibility: visible !important;
    position: relative;
  }

  /* 防止轮播图切换时出现空白 */
  #carouselExampleIndicators2 .carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  #carouselExampleIndicators2 .carousel-item {
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform 0.6s ease-in-out;
  }

  /* 合作伙伴卡片样式 */
  .AOGSSOCIETY_PARTNERS_CARD {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 15px;
    text-align: center;
    font-size: 12px;
    color: #404041;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 5px;
    position: relative;
    z-index: 1;
  }

  .AOGSSOCIETY_PARTNERS_CARD:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .AOGSSOCIETY_PARTNERS_CARD img {
    width: 100%;
    height: 100px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .AOGSSOCIETY_PARTNERS_CARD .card-body {
    padding: 0;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .AOGSSOCIETY_PARTNERS_CARD .card-text {
    margin: 0;
    font-size: 11px;
    line-height: 1.3;
  }

  .AOGSSOCIETY_PARTNERS_CARD .card-text a {
    color: #175480;
    text-decoration: none;
    word-wrap: break-word;
  }

  .AOGSSOCIETY_PARTNERS_CARD .card-text a:hover {
    color: #99C33C;
    text-decoration: underline;
  }

  /* 轮播图按钮样式 */
  .btn-group .btn {
    background: white;
    border: 1px solid #dee2e6;
    color: #175480;
    padding: 8px 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .btn-group .btn:hover {
    background: #175480;
    color: white;
    border-color: #175480;
  }

  .btn-group .btn:focus {
    box-shadow: none;
    outline: none;
  }

  /* 响应式样式 */
  @media (max-width: 768px) {
    #carouselExampleIndicators2 {
      padding: 15px;
    }

    .AOGSSOCIETY_PARTNERS_CARD {
      height: 160px;
      padding: 10px;
    }

    .AOGSSOCIETY_PARTNERS_CARD img {
      height: 80px;
    }

    .AOGSSOCIETY_PARTNERS_CARD .card-text {
      font-size: 10px;
    }
  }

  @media (max-width: 576px) {
    #carouselExampleIndicators2 {
      padding: 10px;
    }

    .AOGSSOCIETY_PARTNERS_CARD {
      height: 140px;
      padding: 8px;
    }

    .AOGSSOCIETY_PARTNERS_CARD img {
      height: 70px;
    }

    .AOGSSOCIETY_PARTNERS_CARD .card-text {
      font-size: 9px;
    }

    .btn-group .btn {
      padding: 6px 10px;
      font-size: 14px;
    }
  }

  #mainBannerCarousel {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: hidden;
  }

  .carousel-inner {
    height: 100%;
    position: relative;
    width: 100%;
  }

  .carousel-item {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 0.6s ease-in-out;
    backface-visibility: hidden;
  }

  .carousel-item.active {
    position: relative;
    transform: translateX(0);
  }

  /* 确保图片完全填充 */
  .carousel-item .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    margin: 0;
    padding: 0;
    border: none;
  }

  /* 优化切换按钮 */
  .carousel-control-prev,
  .carousel-control-next {
    /* width: 5%; */
    margin: 20px;
    opacity: 0.8;
    z-index: 10;
  }

  /* 消除可能的间隙 */
  #mainBannerCarousel * {
    box-sizing: border-box;
  }
</style>


